import napStyles from './../nap.json'

export default {
  default: {
    backgroundColor: napStyles.colors.PrimaryBlack,
    border: `1px solid ${napStyles.colors.PrimaryBlack}`,
    color: napStyles.colors.PrimaryWhite
  },
  inverse: {
    backgroundColor: napStyles.colors.PrimaryWhite,
    border: `1px solid ${napStyles.colors.PrimaryBlack}`,
    color: napStyles.colors.PrimaryBlack
  },
  disabled: {
    color: napStyles.colors.SecondaryGreySky,
    backgroundColor: napStyles.colors.PrimaryWhite,
    border: `1px solid ${napStyles.colors.PrimaryGrey}`
  },
  hover: {
    backgroundColor: napStyles.colors.SecondaryGreyMetal,
    border: `1px solid ${napStyles.colors.SecondaryGreyMetal}`
  },
  hoverInverse: {
    backgroundColor: napStyles.colors.PrimaryGrey,
    border: `1px solid ${napStyles.colors.PrimaryGrey}`
  }
}
